import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

// import { CarsRoutingModule } from './cars-routing.module';
import {MatCardModule} from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {MatRippleModule} from '@angular/material/core';
import {MatDialogModule} from '@angular/material/dialog';
import {CarDialogOverviewComponent} from './car-dialog-overview/car-dialog-overview.component';
import {CarouselModule} from 'primeng/carousel';
import {CarModalNigeriaComponent} from './car-modal/car-modal-nigeria.component';
import {
  NbButtonModule,
  NbCardModule,
  NbDialogModule,
  NbFormFieldModule,
  NbIconModule,
  NbInputModule,
  NbToggleModule,
  NbTooltipModule
} from '@nebular/theme';
import {NbEvaIconsModule} from '@nebular/eva-icons';
import {NgSelectModule} from '@ng-select/ng-select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FreightSharedModule} from '../freight-shared/freight-shared.module';
import {MatIconModule} from '@angular/material/icon';
import {ImageDialogComponent} from './image-dialog/image-dialog.component';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTooltipModule} from '@angular/material/tooltip';
import {ToastModule} from 'primeng/toast';
import {MatRadioModule} from '@angular/material/radio';
import {NgxSliderModule} from '@angular-slider/ngx-slider';
import {MatTableModule} from '@angular/material/table';
import {MatInputModule} from '@angular/material/input';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {FlexModule} from '@angular/flex-layout';
import {MatFormFieldModule} from '@angular/material/form-field';
import {CarModalSellerNigeriaComponent} from './car-modal-seller-nigeria/car-modal-seller-nigeria.component';
import {ConfirmationSellerDialogComponent} from './car-modal-seller-nigeria/confirmation-cancel-seller.component';
import {ThankYouDialogSellerComponent} from './car-modal-seller-nigeria/thank-you-dialog-seller.component';
import {CarsGridSellerNigeriaComponent} from './cars-grid-seller-nigeria/cars-grid-seller-nigeria.component';
import {UserInfoNigeriaModalComponent} from './user-info-nigeria/user-info-nigeria-modal.component';
import {MatTabsModule} from '@angular/material/tabs';
import {TranslateModule} from '@ngx-translate/core';
import {NgCustomsCalculatorComponent} from './ng-customs-calculator/ng-customs-calculator.component';


@NgModule({
    declarations: [
        CarsGridSellerNigeriaComponent,
        CarDialogOverviewComponent,
        CarModalNigeriaComponent,
        CarModalSellerNigeriaComponent,
        ImageDialogComponent,
        ConfirmationSellerDialogComponent,
        ThankYouDialogSellerComponent,
        UserInfoNigeriaModalComponent,
        NgCustomsCalculatorComponent
    ],
  imports: [
    CommonModule,
    // CarsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    FontAwesomeModule,
    MatRippleModule,
    MatDialogModule,
    CarouselModule,
    NbCardModule,
    NbIconModule,
    NbButtonModule,
    NbDialogModule.forRoot(),
    NbIconModule,
    NbEvaIconsModule,
    NbInputModule,
    NgSelectModule,
    NbFormFieldModule,
    ReactiveFormsModule,
    FreightSharedModule,
    NbToggleModule,
    MatIconModule,
    AngularSvgIconModule,
    NbTooltipModule,
    MatBottomSheetModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    ToastModule,
    MatRadioModule,
    NgxSliderModule,
    NgxSliderModule,
    FormsModule,
    MatTableModule,
    MatInputModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    FlexModule,
    MatTabsModule,
    TranslateModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CarsNigeriaModule { }
